import { render, staticRenderFns } from "./MedOcuHabitos.vue?vue&type=template&id=1b4cc56d&scoped=true"
import script from "./MedOcuHabitos.vue?vue&type=script&lang=js"
export * from "./MedOcuHabitos.vue?vue&type=script&lang=js"
import style0 from "./MedOcuHabitos.vue?vue&type=style&index=0&id=1b4cc56d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4cc56d",
  null
  
)

export default component.exports